export interface ILangArr {
  /** 语言 */
  name?: string
  /** 语言标识 */
  value?: string
  icon?: string
}

export const langArr: ILangArr[] = [
  { value: 'ENG', name: 'ENGLISH' }, // 英语
  { value: 'CMN', name: '简体中文' }, // 简体中文
  // { value: 'ZHO', name: '繁体中文' }, // 繁体中文 zho
  { value: 'VIE', name: 'TIẾNG VIỆT' }, // 越南语 vn
  // { value: 'JPN', name: '日本語' }, // 日本语 ja
  // { value: 'THA', name: 'แบบไทย' }, // 泰语 tha
  // { value: 'SAU', name: 'العربية' }, // 阿拉伯语 sa
  // { value: 'DEU', name: 'Deutsch' }, // 德语 de
  // { value: 'SPA', name: 'Español' }, // 西班牙语 es
  // { value: 'FRA', name: 'Français' }, // 法语 fr
  // { value: 'HIN', name: 'हिंदी' }, // 印地语 hi
  // { value: 'KOR', name: '한국어' }, // 韩语 kor
  // { value: 'BRA', name: 'Português' }, // 葡萄牙語（巴西） br
  // { value: 'RUS', name: 'Русский' }, // 俄语 ru
  // { value: 'MSA', name: 'Malaysia' }, // 马来语 ms
  // { value: 'IND', name: 'Indonesia' }, // 印尼语 in
  // { value: 'TR', name: 'Türkçe' }, // 土耳其语 trk

]

/** key value { zh: '中文' } */
export const langMap: ILangArr = arrToMap()

export function arrToMap() {
  const langMap: ILangArr = {}
  langArr.forEach((e) => {
    langMap[e.value] = e.name
  })

  return langMap
}
